import React, { Component } from 'react';

class Header extends Component {
	getCurrentYear(params) {
		return new Date().getFullYear();
	}

	render() {
		return (
			<footer className="footer">
				<div className="container footer-wrapper">
					<span className="footer-text">© {this.getCurrentYear()} Miguel Santos’ Room</span>
				</div>
			</footer>
		);
	}
}

export default Header;
